import { httpsCallable } from 'firebase/functions'

import { getFirebaseFunctions } from '@/lib/firebase/app'
import { parseCallableError } from '@/lib/firebase/errors'
import type { SocialAccount, SocialPlatform } from '@/types/connections'

const GET_ACCOUNT_CALLABLE_NAMES: Record<SocialPlatform, string> = {
  linkedin: 'getLinkedInAccount',
  whatsapp: 'getWhatsAppAccount',
} as const

const CONNECT_CALLABLE_NAMES: Record<SocialPlatform, string> = {
  linkedin: 'connectLinkedIn',
  whatsapp: 'connectWhatsApp',
} as const

const DISCONNECT_CALLABLE_NAMES: Record<SocialPlatform, string> = {
  linkedin: 'disconnectLinkedIn',
  whatsapp: 'disconnectWhatsApp',
} as const

export async function getSocialAccount(platform: SocialPlatform): Promise<SocialAccount | null> {
  try {
    const fnName = GET_ACCOUNT_CALLABLE_NAMES[platform]
    const fn = httpsCallable<void, SocialAccount | null>(getFirebaseFunctions(), fnName)
    const { data } = await fn()
    return data
  } catch (cause) {
    throw parseCallableError(cause)
  }
}

export async function connectSocialAccount(
  platform: SocialPlatform,
  brandName?: string,
): Promise<{ authUrl: string }> {
  try {
    const fnName = CONNECT_CALLABLE_NAMES[platform]
    const fn = httpsCallable<Record<string, unknown>, { authUrl: string }>(
      getFirebaseFunctions(),
      fnName,
    )
    const payload = brandName ? { brandName } : {}
    const { data } = await fn(payload)
    return data
  } catch (cause) {
    throw parseCallableError(cause)
  }
}

export async function disconnectSocialAccount(platform: SocialPlatform): Promise<void> {
  try {
    const fnName = DISCONNECT_CALLABLE_NAMES[platform]
    const fn = httpsCallable<void, { success: true }>(getFirebaseFunctions(), fnName)
    await fn()
  } catch (cause) {
    throw parseCallableError(cause)
  }
}
